/**
 * TanStack Query hooks for `native-reconciliation-link-conversions-to-stripe-bank-deposits`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	nativeReconciliationLinkConversionsToStripeBankDepositsQueryKeys,
	type CreateNativeReconciliationLinkConversionsToStripeBankDepositsBody,
	type ListNativeReconciliationLinkConversionsToStripeBankDepositsResponse,
	type NativeReconciliationLinkConversionsToStripeBankDepositsRow,
} from "./api";

export function useNativeReconciliationLinkConversionsToStripeBankDepositsList(): UseQueryResult<ListNativeReconciliationLinkConversionsToStripeBankDepositsResponse, Error> {
	return useQuery({
		queryKey: nativeReconciliationLinkConversionsToStripeBankDepositsQueryKeys.list(),
		queryFn: list,
	});
}

export function useNativeReconciliationLinkConversionsToStripeBankDepositsCreate(): UseMutationResult<NativeReconciliationLinkConversionsToStripeBankDepositsRow, Error, CreateNativeReconciliationLinkConversionsToStripeBankDepositsBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: nativeReconciliationLinkConversionsToStripeBankDepositsQueryKeys.all });
		},
	});
}

export function useNativeReconciliationLinkConversionsToStripeBankDepositsDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: nativeReconciliationLinkConversionsToStripeBankDepositsQueryKeys.all });
		},
	});
}
